
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, DropZone, FakeDropZone, Topography } from 'components/ui';
import { sendGovtRecordRequest, govtFormReset, sendPatientFormRequest } from 'store/actions/govtDocument.action'
import { govtDocumentSelector } from 'store/reducers/govtDocument.reducer'
import { PreloaderWrapper } from 'components/containers';
import Alert from 'components/ui/Alert/Alert';
import { GovtId as GovtIdProps } from 'types';
import DeleteButton from "../../assets/images/deletebutton.png"
import path from 'path'
import '../govtIDDocUpload/govtIDDocUpload.scss'
import docIcon from '../../assets/images/font-icons/docIcon.svg'
import pdfIcon from '../../assets/images/font-icons/pdfIcon.svg'
import pngIcon from '../../assets/images/font-icons/pngIcon.svg'
import crossIcon from '../../assets/images/font-icons/crossIcon.svg'
import styles from './patientAuth.module.scss';
export const PatientAuthorizationFormUpload = () => {
    const { isSubmitting, error, success } = useSelector(govtDocumentSelector)
    const [govtId, setGovtId] = useState<GovtIdProps>({});
    const [govtIdExt, setGovtIdExt] = useState<any | undefined>({});
    const [uploadedFile, setUploadedFile] = useState<any | undefined>()
    const [userId, setUserId] = useState<string>('')
    const [rid, setRid] = useState<string>('')
    const [username, setUserName] = useState<string>('')
    const [govUpload, setGovUpload] = useState<string>('')

    const dispatch = useDispatch();
    useEffect(() => {
        const url_string = window.location.href;
        const url = new URL(url_string);
        setUserId(url.searchParams.get('user_id') || '')
        setRid(url.searchParams.get('request_id') || '')
        setUserName(url.searchParams.get('username') || '')
        setGovUpload(url.searchParams.get('govt_document') || '')
    }, [])
    const handleUpload = (files: File[], key: 'frontFile' | 'backFile') => {
        setGovtId(govtId => ({ ...govtId, [key]: files[0] }))
        setGovtIdExt({
            name: files[0].name,
            size: (files[0].size / 1024).toFixed(2) + 'kb',
            ext: files[0].name.split('.').pop()
        })
    }
    const handleFileFrontRemove = () => {
        setGovtId(govtId => ({ ...govtId, frontFile: undefined }));
    };

    const handleFileBackRemove = () => {
        setGovtId(govtId => ({ ...govtId, backFile: undefined }));
    };
    const next = () => {
        if (govtId?.frontFile) {
            let fd = new FormData()
            fd.append('user_id', userId || '')
            fd.append('request_id', rid || '')
            fd.append('form_record', govtId.frontFile, `${Math.floor(Date.now() / 1000)}_patient_form${path.extname(govtId.frontFile.name)}`)
            dispatch(sendPatientFormRequest(fd))
        }
    };

    if (isSubmitting) return <PreloaderWrapper />
    else if (success) return (
        <div>
            {govUpload ? (
                <div className='row mt-5 p-auto'>
                    <div className='col-12 col-md-9 ml-auto mr-auto mb-5 text-center'>
                        <Alert type='success' className='alert mx-auto'>{success}</Alert>
                    </div>
                    <div className='col-12 col-md-5 mb-3 text-center ml-auto'>
                        <a href={process.env.REACT_APP_BASE_API_URL + '/patient'} className='card-wrapper d-block text-dark'>
                            <Topography.H4 className='d-block'>Create an Account</Topography.H4>
                            <div className='mt-3'><span className='fa fa-check text-success'></span> Request additional medical records</div>
                            <div className='mt-2'><span className='fa fa-check text-success'></span> Add dependents</div>
                            <div className='mt-2'><span className='fa fa-check text-success'></span> Upload forms for school, camp, and more.</div>
                            <div className='mt-4'><Button className='w-auto m-auto'>Continue</Button></div>
                        </a>
                    </div>
                    <div className='col-12 col-md-5 mb-3 text-center mr-auto'>
                        <a href='/requestor/subscription' className='card-wrapper d-block text-dark'>
                            <Topography.H4 className='d-block'>Subscribe & Share</Topography.H4>
                            <div className='mt-3'><span className='fa fa-check text-success'></span> Access your medical records at anytime.</div>
                            <div className='mt-2'><span className='fa fa-check text-success'></span> Easily share your medical records with any provider.</div>
                            <div className='mt-2'><span className='fa fa-check text-success'></span> Unlimited sharing and faxing of your records.</div>
                            <div className='mt-4'><Button className='w-auto m-auto'>Continue</Button></div>
                        </a>
                    </div>
                </div>
            ) : (<div className='row patient-upload-success'>
                <p style={{ width: '100%', textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '15px', color: '#131414' }}>Patient Form Upload</p>
                <div className='col-12 col-md-9 ml-auto mr-auto mb-2 text-center'>
                    <Alert type='success' className='alert mx-auto'>{"Patient Form Uploaded Successfully"}</Alert>
                </div>
                {/* <div className='col-12 col-md-9 ml-auto mr-auto mb-5 text-center'>
                    <p>Please refresh the desktop browser to continue the form request process.</p>
                </div> */}
            </div>)}
        </div>
    )
    return (
        <div className='row'>
            <div className='col-12'>
                <Topography.H3>{`Patient Form Upload`}</Topography.H3>
                <p className='description'>Please verify that you've finished filling out each section of your form before uploading.</p>

                <div className='row mt-3 mb-5 justify-content-center'>
                    <div className='col-12 col-md-6 mb-5'>
                        <Topography.H4>Form</Topography.H4>
                        {govtId?.frontFile ? (
                            <div className={styles.uploadedfile}>{govtIdExt.ext == 'png' ? (
                                <div className={styles.uploadOut}>
                                    <img src={pngIcon} className='mr-2' style={{width: '49px'}} id='rushRequestTool' />
                                    <div style={{ flex: 1 }}>
                                        <p className={styles.fileName}>{govtIdExt.name}</p>
                                        <p className={styles.fileSize}>{govtIdExt.size}</p>
                                    </div>
                                    <div style={{ paddingTop: '15px' }}>
                                        <img src={crossIcon} className="deleteButton" onClick={() => handleFileFrontRemove()} />
                                    </div>
                                </div>
                            )
                                : (govtIdExt.ext == 'docx' || govtIdExt == 'doc') ? (
                                    <div className={styles.uploadOut}>
                                        <img src={docIcon} className='mr-2' id='rushRequestTool' />
                                        <div style={{ flex: 1 }}>
                                            <p className={styles.fileName}>{govtIdExt.name}</p>
                                            <p className={styles.fileSize}>{govtIdExt.size}</p>
                                        </div>
                                        <div style={{ paddingTop: '15px' }}>
                                            <img src={crossIcon} className="deleteButton" onClick={() => handleFileFrontRemove()} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.uploadOut}>
                                        <img src={pdfIcon} className='mr-2' id='rushRequestTool' />
                                        <div style={{ flex: 1 }}>
                                            <p className={styles.fileName}>{govtIdExt.name}</p>
                                            <p className={styles.fileSize}>{govtIdExt.size}</p>
                                        </div>
                                        <div style={{ paddingTop: '15px' }}>
                                            <img src={crossIcon} className="deleteButton" onClick={() => handleFileFrontRemove()} />
                                        </div>
                                    </div>
                                )}</div>
                        ) : (
                            <DropZone className='inputtext mobile_upload' maxFileCount={1} maxSize={1024 * 1024 * 25} onUpload={files => handleUpload(files, 'frontFile')} selectedFiles={govtId.frontFile ? [govtId.frontFile] : []} filenames={[`${username}_front`]} accept='image/*, .heif, .heic,.pdf, .doc, .docx, .jpg, .png, .jpeg' showEye={true} placeholder={"Tap here to upload"} placeholder2={"Supports png, pdf, doc, image document"} className2={"textsmall"} />
                        )}
                    </div>

                </div>
                <div className='row mb-5 justify-content-md-center'>
                    <div className='col-sm-2 '>
                        <Button className={'ml-auto'} onClick={next} disabled={!govtId?.frontFile}>Submit</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}